import { Component, OnInit, AfterContentChecked, ViewEncapsulation, AfterViewInit, ViewChild, ChangeDetectorRef, HostListener, OnDestroy, ElementRef, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription, debounceTime, filter, fromEvent } from 'rxjs';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

import { PATH, ROUTES_MOBILE } from '@app/constants';
import { ModalCustomOptions } from '@app/models';
import { AuthService, UserService, DeviceService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { environment } from 'src/environments/environment';
import { UserInfo } from '@interfaces/app';
import { CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';

declare var cordova: any;
@Component({
   selector: 'mnf-shell',
   templateUrl: './shell.component.html',
   styleUrls: ['./shell.component.scss'],
   encapsulation: ViewEncapsulation.None,
   animations: []
})
export class ShellComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {
   lastScrollTop = 0;
   isHeadVisible = true;

   @HostListener('window:scroll', [])
   onWindowScroll(): void {
     requestAnimationFrame(() => {
       const currentScroll = document.documentElement.scrollTop || window.pageYOffset;

       this.zone.run(() => {
         if (currentScroll > this.lastScrollTop && currentScroll > 150) {
           this.isHeadVisible = false;
         } else if (currentScroll < this.lastScrollTop) {
           this.isHeadVisible = true;
         }

         this.lastScrollTop = Math.max(0, currentScroll);
       });
     });
   }

   @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective;

   @ViewChild(MatSidenav)
   sidenav!: MatSidenav;
   devMenu!: MatSidenav;

   panelOpenState = false;

   subs: { [prop: string]: Subscription } = {};
   user: UserInfo;

   path = PATH;

   isDeveloper = false;
   userLoaded = true;
   showDiv = false;

   isModalOneOpen: boolean = false;
   isModalTwoOpen: boolean = false;
   investModal: boolean = false;
   accountModal: boolean = false;
   routerContainer: boolean = false;
   private resizeSubscription: Subscription;
   private clickSubscription: Subscription;
   private isBrowser: boolean;
   private routerSubscription: Subscription;
   currentRoute: string = '';

   version = environment.version;

   regStep: any;
   balance: string;
   totalInvested: string;

   routesWithNoAuth = [new RegExp(PATH.PLD), new RegExp(PATH.PROJECTS), new RegExp(PATH.RESALE), new RegExp(PATH.UPDATE_INFO), new RegExp(PATH.AVAILABLE_PROJECTS)];

   lastSession?: string;
   firstModalInvest: any;
   secondModalAccount: any;

   isiOSDevice: boolean;

   actualRoute: string;
   PATHS_ROUTE = ROUTES_MOBILE;

   platformType: 'ios' | 'android' | 'web' = 'web';
   isNativePlatform: boolean = false;
   modalDashboard: MatDialogRef<any>;

   isUserNoAuth: number = 0;
   
   /** Información del dispositivo */
   deviceInfo = null;
   @ViewChild('elem') elem: ElementRef;
   @ViewChild('elemBtn') elemBtn: ElementRef;

   @HostListener('window:resize', ['$event'])
   onResize() {
      this.deviceServ.changeDeviceWith();
   }

   @ViewChild('scrollable', { static: true })
   private scrollable?: ElementRef<HTMLElement>;

   constructor(
      private readonly router: Router,
      private readonly modal: ModalService,
      private readonly authServ: AuthService,
      private readonly userServ: UserService,
      private readonly observer: BreakpointObserver,
      private readonly cdRef: ChangeDetectorRef,
      private readonly deviceServ: DeviceService,
      private readonly deviceService: DeviceDetectorService,
      private readonly toastServ: ToastrService,
      private readonly currency: CurrencyPipe,
      private readonly modalServ: ModalService,
      private readonly activateRoute: ActivatedRoute,
      private readonly zone: NgZone,
      @Inject(PLATFORM_ID) private readonly platformId: Object
   ) { this.getInfoDevice(); this.platformType = typeof cordova !== 'undefined' ? 'ios' : 'web'; 
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.activateRoute.queryParams.subscribe(params => {
         this.isUserNoAuth = Number(params?.isUserNoAuth);
      })
   }

   onOutletActivate() {
       setTimeout(() => {
         const el1 = this.scrollable?.nativeElement;
         const el2 = document.querySelector<HTMLElement>('mat-sidenav-content.mat-drawer-content');
      
         [el1, el2].forEach(el => {
            if (el) {
               el.scrollTo({ top: 0, behavior: 'smooth' });
            }
         });
       }, 0);
   }

   ngOnInit() {
      window.addEventListener('scroll', this.onWindowScroll.bind(this), { passive: true });
      // Actualizar el valor de actualRoute cuando la URL cambie
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.actualRoute = this.getUrlForMobile(this.router.url);
        }
      });

      // Inicializar actualRoute con la ruta actual
      this.actualRoute = this.getUrlForMobile(this.router.url);

      this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';

      this.subs.a = this.userServ.userInfo.subscribe(user => {
         if (!user) return;

         this.user = user;

         this.regStep = this.user?.regStep;

         this.isDeveloper = user.type === 'd';

         this.userLoaded = true;
         this.ngAfterViewInit();
      });

      if (environment.isMobile) {
         this.subs.d = this.deviceServ.nativeDevice.subscribe(info => {
            this.isiOSDevice = info.operatingSystem === 'ios';
         });
      }

      if (!this.routesWithNoAuth.find(r => r.test(this.router.url))) {
         //Obtener los valores de balance y total invertido
         this.userServ.getUserInf(true).subscribe((user: UserInfo) => {
            const balance = this.currency.transform(
               user?.wallet?.balance || 0,
            )
            this.balance = balance
               .split('.')
               .map((n,i) => (i === 0 ? n : `<small>${n}</small>`))
               .join('.');
         
            const total = user?.participations?.reduce(
               (p, c) => p + c.partValue * c.amount,
               0
            );   
         
            this.totalInvested = `${this.currency
               ?.transform((user?.wallet?.balance || 0) + total)
               ?.split('.')
               ?.map((n,i) => (i === 0 ? n : `<small>${n}</small>`))
               ?.join('.')}`;
         })
      } else {
         this.userLoaded = true;
         this.ngAfterViewInit();
      }
      if (this.isBrowser) {
         setTimeout(() => {
           this.initModal();
           this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
         ).subscribe((event: NavigationEnd) => {
            this.currentRoute = event.url;
         })
         this.currentRoute = this.currentRoute.split('/').pop() || '';
         }, 100);
         
         // Suscripción al resize solo en el navegador
         this.checkScreenSize();
         this.resizeSubscription = fromEvent(window, 'resize')
           .pipe(debounceTime(100))
           .subscribe(() => {
             this.checkScreenSize();
           });
   
         // Suscripción a clicks solo en el navegador
         this.clickSubscription = fromEvent(document, 'click').subscribe((event: Event) => {
           const target = event.target as HTMLElement;
           const clickedLink = target.closest('a');
           if (clickedLink && this.isModalOneOpen && !clickedLink.classList.contains('keep-modal-open')) {
             this.closeModal('invest');
           }
           if (clickedLink && this.isModalTwoOpen && !clickedLink.classList.contains('keep-modal-open')) {
             this.closeModal('account');
           }
           if(clickedLink && this.showDiv){
            this.showDiv = !this.showDiv;
           }
         });         
       }
   }

   ngAfterViewInit() {
      this.toastServ.overlayContainer = this.toastContainer;
      this.deviceServ.changeDeviceWith();
      setTimeout(() => this.observer.observe(['(max-width: 991px)']).subscribe((res) => {
         if (res.matches) {
            if (this.sidenav) {
               this.sidenav.mode = 'over';
               this.sidenav.close();
            }
            if (this.devMenu) {
               this.devMenu.mode = 'over';
               this.devMenu.close();
            }
         } else {
            if (this.sidenav) {
               this.sidenav.mode = 'side';
               this.sidenav.open();
            }
            if (this.devMenu) {
               this.devMenu.mode = 'side';
               this.devMenu.open();
            }
         }
      }), 0);
   }

   ngAfterContentChecked(): void {
      this.cdRef.detectChanges();
   }

   getUrlForMobile(url: string): string {
      let route = this.PATHS_ROUTE.find(r => r.value === url);
      return route?.label || '';      
   }

   /** Obtener información del dispositivo y guardarla en una variable global */
   getInfoDevice() {
      this.deviceInfo = this.deviceService.getDeviceInfo();
   }

   getState(outlet: RouterOutlet) {
      return outlet.activatedRouteData.state;
   }

   routeToWithdraw(){
      if(this?.user?.wallet?.balance == 0 && this?.user?.stepRegister >= 5){
         this.modalNotMoney();
      }else{
         this.router.navigate([PATH.ROUTE_WITHDRAW_HOME]);
      }
   }

   modalNotMoney() {
      const m = (this.modalDashboard = this.modalServ.modalCustom({
         img: 'https://static.monific.com/assets/assets-app/img/icon/img/no_balance.svg',
         title: 'Sin fondos para retirar',
         message:
            'Por el momento no cuentas con fondos para retirar, espera los rendimientos de tus inversiones o tus ventas en el mercado secundario',
         buttonText: 'Entendido',
      }));
      return m;
   }

   link(route: string) {
      this.router.navigate([route]);

      if (this.sidenav && this.sidenav.mode === 'over') this.sidenav.close();
      if (this.devMenu && this.devMenu.mode === 'over') this.sidenav.close();
   }

   logout() {
     const logout = this.modalServ.openModalLogout();
   
     logout.beforeClosed().subscribe(r => {
       if (r === true) {
         this.authServ.logout();
       }
     });
   }

   userInfoRedirect() {
      this.subs.b = this.userServ.getUserInf().subscribe(u => {
         if (u.wallet) {
            this.router.navigate([PATH.ROUTE_PROFILE_COMPLETE]);
         } else {
            this.router.navigate([PATH.ROUTE_PROFILE_REG]);
         }

         if (this.sidenav.mode === 'over') this.sidenav.close();
      });
   }

   closeSubmenu(panel: MatExpansionPanel) {
      setTimeout(() => panel.close(), 300);
      setTimeout(() => panel.close(), 600);
   }

   openModal(modalType: 'invest' | 'account') {
      if (modalType === 'invest' && this.firstModalInvest) {
        this.firstModalInvest.show();
      } else if (modalType === 'account' && this.secondModalAccount) {
        this.secondModalAccount.show();
      }
    }

   closeModal(modalType: 'invest' | 'account') {
      if (!this.isBrowser) return;
      
      const modal = modalType === 'invest' ? this.firstModalInvest : this.secondModalAccount;
      
      if (modal) {
        modal.hide();
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
   }

   divState(){
      this.showDiv = !this.showDiv;
   }

   //Inicializar modales 
   initModal(){
      if(this.isBrowser){
         const modalInvestElement = document.getElementById('investModal');
         if(modalInvestElement){
            this.firstModalInvest = new (window as any).bootstrap.Modal(modalInvestElement, {
               keyboard: false
            })

            modalInvestElement.addEventListener('shown.bs.modal', () => {
               this.isModalOneOpen = true;
            })

            modalInvestElement.addEventListener('hidden.bs.modal', ()=>{
               this.isModalOneOpen = false;
            })
         }
          // Inicializar modal de cuenta
         const modalAccountElement = document.getElementById('accountModal');
         if (modalAccountElement) {
           this.secondModalAccount = new (window as any).bootstrap.Modal(modalAccountElement, {
             keyboard: false
           });
           
           modalAccountElement.addEventListener('shown.bs.modal', () => {
             this.isModalTwoOpen = true;
           });
           
           modalAccountElement.addEventListener('hidden.bs.modal', () => {
             this.isModalTwoOpen = false;
           });
           }
      }
   }

   //Verificar tamaño de pantalla para modales en mobile
   checkScreenSize(): void {
      if (!this.isBrowser) return;
  
      const isLargeScreen = window.innerWidth >= 992;
      
      if (isLargeScreen) {
      //Cerrar los modales si estan abiertos para web
         if(this.isModalOneOpen && this.firstModalInvest){
            this.closeModal('invest');
         }

         if(this.isModalTwoOpen && this.secondModalAccount){
            this.closeModal('account');
         }
        this.investModal = false;
        this.accountModal = true;
        
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      } else {
        this.routerContainer = true;
        this.investModal= true;
        this.accountModal = false;
      }
    }

    ngOnDestroy(): void {
      if (this.subs.a) this.subs.a.unsubscribe();
      if (this.subs.b) this.subs.b.unsubscribe();
      if (this.subs.d) this.subs.d.unsubscribe();
      if (this.routerSubscription) { this.routerSubscription.unsubscribe(); }
   }
}
